import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {MediaLibraryWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/mediaLibraryWorkspaceCapability/domain/MediaLibraryWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type MediaLibraryWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.mediaLibrary> & {
    fixedUdoTemplates: {
        [MediaLibraryWorkspaceCapabilityUdoTemplateKey.dirent]: {
            udoAdditionalColumnIds: {
                data: Uuid;
                name: Uuid;
                parentFolderId: Uuid;
                status: Uuid;
                type: Uuid;
            };
        };
        [MediaLibraryWorkspaceCapabilityUdoTemplateKey.direntEvent]: {
            udoAdditionalColumnIds: {
                actorUserId: Uuid;
                direntId: Uuid;
                eventType: Uuid;
                isProcessed: Uuid;
                payload: Uuid;
                userAgent: Uuid;
            };
        };
    };
};
export const mediaLibraryWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [MediaLibraryWorkspaceCapabilityUdoTemplateKey.dirent]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                data: uuidZodValidator,
                name: uuidZodValidator,
                parentFolderId: uuidZodValidator,
                status: uuidZodValidator,
                type: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
        [MediaLibraryWorkspaceCapabilityUdoTemplateKey.direntEvent]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                actorUserId: uuidZodValidator,
                direntId: uuidZodValidator,
                eventType: uuidZodValidator,
                isProcessed: uuidZodValidator,
                payload: uuidZodValidator,
                userAgent: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<MediaLibraryWorkspaceCapabilityUdoBindings>;
